import { FC } from "react";

interface RoundedPlusProps {
  className?: string;
  width?: number;
  height?: number;
  fill?: string;
}
const RoundedPlus: FC<RoundedPlusProps> = ({
  className = "",
  width = 25,
  height = 24,
  fill = "",
}) => {
    return (
        <>
            <svg
              className={className}
              width={width}
              height={height}
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0229 2 22.5 6.47715 22.5 12C22.5 17.5229 18.0229 22 12.5 22C6.97715 22 2.5 17.5229 2.5 12ZM12.5 3.81818C7.9813 3.81818 4.31818 7.4813 4.31818 12C4.31818 16.5187 7.9813 20.1818 12.5 20.1818C17.0187 20.1818 20.6818 16.5187 20.6818 12C20.6818 7.4813 17.0187 3.81818 12.5 3.81818ZM12.5 7.45455C13.0021 7.45455 13.4091 7.86156 13.4091 8.36364V11.0909H16.1364C16.6384 11.0909 17.0455 11.4979 17.0455 12C17.0455 12.5021 16.6384 12.9091 16.1364 12.9091H13.4091V15.6364C13.4091 16.1384 13.0021 16.5455 12.5 16.5455C11.9979 16.5455 11.5909 16.1384 11.5909 15.6364V12.9091H8.86364C8.36156 12.9091 7.95455 12.5021 7.95455 12C7.95455 11.4979 8.36156 11.0909 8.86364 11.0909H11.5909V8.36364C11.5909 7.86156 11.9979 7.45455 12.5 7.45455Z"
                fill={fill}
              />
            </svg>
            
        </>
    )
}

export default RoundedPlus;